import { put, takeEvery } from "redux-saga/effects";

//Actions
import * as ACTIONS from "./../../actions/actionConstants";

//Auth
import { db } from "./../../firebase";

function* handleProfile(action) {
  //Unpack
  const { model, payload } = action.meta;
  /*
  
  HANDLE SIGN UP

  */
  if (model === "forms.profile") {
    const { cUID, uUID, client } = action.meta;

    //If client is updating profile, do this.
    if (cUID) {
      yield db.watchClientProfile(cUID);
      yield db.doUpdateClientProfile(cUID, payload);

      yield put({
        type: ACTIONS.OPEN_SNACKBAR,
        payload: {
          variant: "info",
          message: `profile updated`
        }
      });
    }

    //If user is updating profile, do this.
    if (uUID) {
      yield db.watchUserProfile(client, uUID);
      yield db.doUpdateUserProfile(uUID, client, payload);

      yield put({
        type: ACTIONS.OPEN_SNACKBAR,
        payload: {
          variant: "info",
          message: `profile updated`
        }
      });
    }
  }
}

export function* profileSaga() {
  yield takeEvery(ACTIONS.SUBMIT_EDIT_PROFILE, handleProfile);
}



// WEBPACK FOOTER //
// ./src/sagas/auth/profile.js